import { Alert, Box, Grid } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import authService, { AuthenticationResultStatus } from "../components/api-authorization/AuthorizeService";
import { MyButton } from "../components/my-button/MyButton";
import { MyTextField } from "../components/my-text-field/MyTextField";
import { ValidTextRegExp } from "../Constant";

function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (decodeURIComponent(pair[0]) === variable) {
      return decodeURIComponent(pair[1]);
    }
  }
}

function navigateToReturnUrl(returnUrl) {
  // It's important that we do a replace here so that we remove the callback uri with the
  // fragment containing the tokens from the browser history.
  // window.history.pushState(null, null, returnUrl);
  window.location.replace(returnUrl);
}

export const LoginPage = (props) => {
  const { t, i18n } = useTranslation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState(null);

  const login = async () => {
    var returnUrl = getQueryVariable("returnUrl");
    const result = await authService.signInWithIdentity(username, password, returnUrl);
    switch (result.status) {
      case AuthenticationResultStatus.Success:
        navigateToReturnUrl(returnUrl ?? props.returnUrl ?? "/");
        break;
      case AuthenticationResultStatus.Fail:
        setMessage(t("invalid_credential"));
        // this.setState({ message: result.message });
        break;
      default:
        throw new Error(`Invalid status result ${result.status}.`);
    }
  };

  return (
    <Box>
      <Grid container className="container custom padding bottom-2" justifyContent="center">
        <Grid item>
          <h1>{t("login").toUpperCase()}</h1>
          <MyTextField label={t("username")} value={username} onChange={setUsername} regExp={ValidTextRegExp} />
          <MyTextField type="password" label={t("password")} value={password} onChange={setPassword} />
          <MyButton className="margin bottom-1" onClick={(e) => login()} text={t("login")} />
          {message && (
            <Alert variant="filled" severity="error" className="margin top-1 bottom-1">
              {message}
            </Alert>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
